import { useEffect, useState } from 'react';
import { adminApi } from '@formosa/shared/api/admin';
import { formatOptionalId } from './depositConstants';

export default function DepositAuditModal({ open, row, onClose, onSaved }) {
  const [decision, setDecision] = useState('PASS');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (open && row) {
      setDecision('PASS');
      setError('');
    }
  }, [open, row?.id]);

  if (!open || !row) {
    return null;
  }

  function resetForm() {
    setDecision('PASS');
    setError('');
  }

  async function handleSubmit(event) {
    event.preventDefault();
    setSubmitting(true);
    setError('');
    try {
      await adminApi.depositOfflineAudit({
        id: row.id,
        pass: decision === 'PASS',
      });
      onSaved?.();
      onClose();
    } catch (err) {
      setError(err.message || '審核失敗');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="admin-modal-overlay" role="presentation" onClick={onClose}>
      <div
        className="admin-modal"
        role="dialog"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="admin-modal__header">
          <h3>修改 [{formatOptionalId(row.id)}]</h3>
          <button type="button" className="admin-modal__close" onClick={onClose}>
            ×
          </button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="admin-modal__body">
            <div className="form-field">
              <span className="form-label">
                <span className="required-mark">*</span> 狀態
              </span>
              <div className="radio-row">
                <label>
                  <input
                    type="radio"
                    name="depositAuditDecision"
                    value="PASS"
                    checked={decision === 'PASS'}
                    onChange={() => setDecision('PASS')}
                  />
                  成功
                </label>
                <label>
                  <input
                    type="radio"
                    name="depositAuditDecision"
                    value="REJECT"
                    checked={decision === 'REJECT'}
                    onChange={() => setDecision('REJECT')}
                  />
                  失敗
                </label>
              </div>
            </div>
            {error && <div className="alert alert-error">{error}</div>}
          </div>
          <div className="admin-modal__footer admin-modal__footer--center">
            <button type="submit" className="btn btn-success" disabled={submitting}>
              {submitting ? '提交中…' : '提交'}
            </button>
            <button
              type="button"
              className="btn btn-warning"
              onClick={resetForm}
              disabled={submitting}
            >
              重置
            </button>
            <button type="button" className="btn btn-danger" onClick={onClose} disabled={submitting}>
              關閉
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
